import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyImgDirective } from './lazy-load.directive';

@NgModule({
  exports: [LazyImgDirective],
  imports: [CommonModule, LazyImgDirective],
})
export class LazyImgModule {}
